import React, { useCallback, useState } from "react";
import { cn } from "../../utils/cn";

import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import i18n from "../../i18n";

interface DateTimePickerInputProps {
  label: string;
  required?: boolean;
  value?: Date | null | string;
  labelStyle?: string;
  onChange: (value: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  error?: string;
  errorStyle?: string;
  readOnly?: boolean;
}

const customStyles =
  "flex py-3 px-4 w-full rounded-[15px] cursor-pointer border-2 bg-transparent text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-soft outline-none focus:border-purple-secondary focus:ring-0 disabled:cursor-not-allowed";

const DatePickerInput = ({
  label,
  labelStyle,
  value,
  required = false,
  onChange,
  minDate,
  maxDate,
  error,
  errorStyle,
  readOnly = false,
}: DateTimePickerInputProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenCalendar = useCallback(() => {
    setTimeout(() => setIsOpen(true), 10);
  }, []);

  return (
    <div className="relative flex flex-col gap-[3px]">
      <div className="relative flex items-center gap-2">
        {label && (
          <>
            <label className={cn("text-[13px] font-normal", labelStyle)}>
              {label} {required && <span className="text-red-500">*</span>}
            </label>
          </>
        )}
      </div>

      <div className={cn(customStyles)}>
        <DatePicker
          value={value}
          clearIcon={null}
          onChange={(date) => onChange(date as Date | null)}
          minDate={minDate}
          maxDate={maxDate}
          disabled={readOnly}
          calendarIcon={null}
          isOpen={isOpen}
          onCalendarOpen={handleOpenCalendar}
          format="dd/MM/yyyy"
        />
      </div>

      {!!error && (
        <p
          className={cn(
            "text-red-600 text-[10px] mt-[1px] absolute -bottom-[15px] italic",
            i18n.language === "en" ? "left-[2px]" : "right-[2px]",
            errorStyle
          )}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default React.memo(DatePickerInput);
